import type { Resource } from '../../';
export const product_sizeChart_measurements_eu: Resource = {"default":"Europe"};
